<ng-container *ngIf="imageUrl && imagePosition === 'Top'">
  <ng-container *ngTemplateOutlet="image"></ng-container>
</ng-container>
<div
  *ngIf="rowTextDetails?.freeformTextValue"
  class="markdown break grid__col-12 guts-p-h-0"
  [ngClass]="imagePosition === 'Top' ? 'guts-p-t-1' : 'guts-p-b-1 guts-p-t-0'"
  [innerHtml]="
    rowTextDetails.freeformTextValue | markdownToHtml: { allowImages: true }
  "
></div>
<ng-container *ngIf="imageUrl && imagePosition === 'Bottom'">
  <ng-container *ngTemplateOutlet="image"></ng-container>
</ng-container>

<ng-template #image>
  <img
    *ngIf="imageUrl"
    [src]="imageUrl"
    [alt]="altText"
    [title]="altText"
    class="not-too-wide"
  />
</ng-template>
